import React from 'react';
import { Mail, Phone, MapPin, Linkedin, YoutubeIcon } from 'lucide-react';
import CookieConsent from './CookieConsent'; // ✅ Adjust if needed
import NewsletterSubscribe from './NewsletterSubscribe';


const Footer: React.FC = () => {
  const handleManageCookies = () => {
    // Trigger cookie banner via sessionStorage flag
    sessionStorage.setItem('manual_cookie_open', 'true');
    // Reload to re-trigger useEffect in CookieConsent
    window.location.reload();
  };

  return (
    <footer className="bg-gray-900 text-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img src="WHITELOGO.png" alt="HARMITON WebTech Logo" className="h-8 w-8" />
              <span className="text-2xl font-bold">
                HARMITON <span className="text-blue-400">WebTech</span>
              </span>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Empowering businesses with innovative IT and business services.
              Making digital growth accessible, affordable, and results-driven.
            </p>
            <div className="flex space-x-4">
              <a href="https://youtube.com/@harmitonwebtech?si=VDcYKW7HOE0sG5uC" aria-label="Harmiton WebTech on YouTube" className="text-gray-300 hover:text-blue-400 transition-colors">
                <YoutubeIcon className="h-5 w-5" />
              </a>
              <a href="https://www.linkedin.com/company/harmiton-webtech/" aria-label="Harmiton WebTech on LinkedIn" className="text-gray-300 hover:text-blue-400 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-300 hover:text-white hover:underline transition-colors">Home</a></li>
              <li><a href="/about" className="text-gray-300 hover:text-white hover:underline transition-colors">About Us</a></li>
              <li><a href="/contact" className="text-gray-300 hover:text-white hover:underline transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li><a href='#services' className="text-gray-300 hover:text-white">Web Development</a></li>
              <li><a href='#services' className="text-gray-300 hover:text-white">App Development</a></li>
              <li><a href='#services' className="text-gray-300 hover:text-white">Business Strategy</a></li>
              <li><a href='#services' className="text-gray-300 hover:text-white">Data Analytics</a></li>
              <li><a href='#services' className="text-gray-300 hover:text-white">SEO & Marketing</a></li>
              <li><a href='#services' className="text-gray-300 hover:text-white">UI/UX Design</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Get In Touch</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-blue-400" />
                <a
                  href="mailto:harmitonwt@gmail.com"
                  className="text-gray-300 hover:text-white hover:underline transition-colors"
                >
                  harmitonwt@gmail.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-blue-400" />
                <a
                  href="tel:+918451985096"
                  className="text-gray-300 hover:text-white hover:underline transition-colors"
                >
                  +91 8451985096
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="h-5 w-5 text-blue-400" />
                <span className="text-gray-300">India</span>
              </div>
              <div>
              <p className="text-lg font-semibold mb-1">Subscribe To Our Newsletter</p>
              <NewsletterSubscribe />
            </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              © {new Date().getFullYear()} HARMITON WebTech. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0 items-center">
              <a href="/privacy-policy" className="text-gray-300 hover:text-white text-sm transition-colors">Privacy Policy</a>
              <a href="/terms-of-service" className="text-gray-300 hover:text-white text-sm transition-colors">Terms of Service</a>
              <button
                onClick={handleManageCookies}
                className="text-gray-300 hover:text-white text-sm transition-colors focus:outline-none"
                aria-label='Manage Cookies'
                style={{ textDecoration: 'none', background: 'none', border: 'none' }}
              >
                Manage Cookies
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Always render banner — it decides visibility itself */}
      <CookieConsent />
    </footer>
  );
};

export default Footer;
